export default "__VITE_ASSET__rZWm1Ktw__"